import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper.js";

export const youtubeShoppingReduxAPI = createApi({
  reducerPath: "youtubeShoppingReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["YtShoppingStatus"],

  endpoints: (builder) => ({
    //GET Queries
    getYoutubeEarningsData: builder.query({
      query: ({ startDate, endDate }) =>
        getQueryStringWithCreator(
          `c/getYoutubeEarningsData?startDate=${startDate}&endDate=${endDate}`
        ),
    }),
    getBrandWiseYoutubeEarningsData: builder.query({
      query: ({ startDate, endDate, brandId }) =>
        getQueryStringWithCreator(
          `c/getBrandWiseYoutubeEarningsData?startDate=${startDate}&endDate=${endDate}&brandId=${brandId}`
        ),
    }),
    fetchShowYtEarningsStatus: builder.query({
      query: () => getQueryStringWithCreator(`c/fetchShowYtEarningsStatus`),
      providesTags: ["YtShoppingStatus"],
    }),

    updateShowYtEarningsForCreator: builder.mutation({
      query: (body) => ({
        url: `c/updateShowYtEarningsForCreator`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["YtShoppingStatus"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetYoutubeEarningsDataQuery,
  useLazyGetBrandWiseYoutubeEarningsDataQuery,
  useUpdateShowYtEarningsForCreatorMutation,
  useLazyFetchShowYtEarningsStatusQuery,
} = youtubeShoppingReduxAPI;
